<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.date') }}</div>
                <CalendarSelect v-model="searchParams.date" mode="date" />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.hotel') }}</div>
                <el-select
                  v-model="searchParams.hotelIdList"
                  multiple
                  collapse-tags
                  filterable
                  clearable
                  placeholder=""
                >
                  <el-option
                    v-for="item in hotelOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">
                {{ $t('views.report.lostPropertyReport') }}
              </span>
            </div>
            <div class="flex" style="gap: 10px">
              <InfoBtn @click="noteDialogVisible = true" />
              <el-dropdown trigger="click" @command="onClickDropdownItem">
                <das-button
                  color="primary"
                  size="medium"
                  :rounded="false"
                  outline
                  icon
                >
                  <i class="el-icon-download"></i>
                </das-button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">
                    {{ $t('button.exportPdf') }}
                  </el-dropdown-item>
                  <el-dropdown-item command="excel">
                    {{ $t('button.exportExcel') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <hr />

          <div v-loading="gridLoading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              :default-col-def="defaultColDef"
              class="agGrid"
              :auto-size-cell="true"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('dialog.titleNote')"
      :visible.sync="noteDialogVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="note-container">
            <ul>
              <li>Vị trí/Phòng: Nơi tìm thấy đồ của khách</li>
              <li>Đặt phòng: mã đặt phòng</li>
              <li>Tên khách: Tên khách thất lạc đồ</li>
              <li>Số điện thoại: hiển thị số điện thoại của khách</li>
              <li>Tên đồ vật: tên đồ vật thất lạc</li>
              <li>Ghi chú: ghi chú được lấy từ ghi chú đồ thất lạc</li>
              <li>Trạng thái: Trạng thái của đồ thất lạc được tìm thấy</li>
              <li>Ngày trả lại: Ngày trả lại đồ thất lạc cho khách</li>
              <li>Tìm thấy bởi: Hiển thị tên nhân viên tìm thấy</li>
              <li>
                Người trả lại: Hiển thị tên nhân viên trả lại đồ cho khách
              </li>
              <li>
                Người xác nhận: hiển thị tên nhân viên xác nhận có người tìm
                thấy và đã được trả lại cho khách
              </li>
            </ul>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="noteDialogVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DasButton from '@/components/ui/DasButton.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import { getAllHotel } from '@/api/hotel.js'
import InfoBtn from './components/InfoBtn.vue'
import {
  getLostItemListApi,
  getLostItemListApiExcel
} from '@/api/booking_service/lostItem'
import { downFile } from '@/utils/file-handler'
// import { dateFormatter } from '@/utils/dataFormatter'

const getDefaultSearchParams = () => ({
  hotelIdList: null,
  date: null
})

export default {
  components: {
    DasButton,
    CalendarSelect,
    InfoBtn
  },
  data() {
    return {
      noteDialogVisible: false,
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        wrapText: true,
        autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      searchParams: getDefaultSearchParams(),

      hotelOptions: [],
      gridLoading: false,
      columns: [
        {
          headerName: this.$t('grid.column.foundDate'),
          field: 'date_found',
          cellRenderer: params => {
            return params.value?.slice(0, 11)
          },
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 130,
          maxWidth: 130
        },
        {
          headerName: this.$t('grid.column.positionOrRoom'),
          field: 'location',
          // cellClass: "grid-cell-centered",
          // width: 100,
          // flex: 1,
          sortable: false,
          minWidth: 150
        },
        {
          headerName: this.$t('grid.column.bookingRoom'),
          field: 'recode',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 100,
          maxWidth: 140
        },
        {
          headerName: this.$t('grid.column.customerName'),
          field: 'traveller_nm',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 150,
          flex: 1
        },
        {
          headerName: this.$t('grid.column.thingsName'),
          field: 'item_nm',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 150,
          // maxWidth: 200
          flex: 1
        },
        {
          headerName: this.$t('grid.column.phoneNum'),
          field: 'phone_number',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 150,
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.note'),
          field: 'note',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 250,
          flex: 2
        },
        {
          headerName: this.$t('grid.column.status'),
          field: 'status',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 150
        },
        {
          headerName: this.$t('grid.column.returnDate'),
          field: 'return_date',
          cellRenderer: params => {
            return params.value?.slice(0, 11)
          },
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 120,
          maxWidth: 120
        },
        {
          headerName: this.$t('grid.column.foundBy'),
          field: 'finder_nm',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 140
        },
        {
          headerName: this.$t('grid.column.returnedByPerson'),
          field: 'returner_nm',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 140
        },
        {
          headerName: this.$t('grid.column.confirmedByPerson'),
          field: 'confirmer_nm',
          // cellClass: "grid-cell-centered",
          // width: 150,
          sortable: false,
          minWidth: 140
        }
      ],
      rows: []
    }
  },
  async mounted() {
    await this.getHotelOptions()
    this.attachData()
  },
  methods: {
    // SELECT OPTIONS
    async getHotelOptions() {
      await getAllHotel().then(res => {
        this.hotelOptions = res.data
      })
    },

    getDefaultSearchParams() {
      return {
        ...getDefaultSearchParams()
      }
    },

    onSearch() {
      this.attachData()
    },
    onReset() {
      this.searchParams = this.getDefaultSearchParams()
      this.attachData()
    },
    onClickDropdownItem(cmmd) {
      // this.$message('click on item ' + cmmd)
      switch (cmmd) {
        case 'pdf':
          break
        case 'excel':
          this.downloadExcel()
          break
        default:
          this.$message('click on item ' + cmmd)
          break
      }
    },
    async attachData() {
      this.gridLoading = true
      const queryParams = {
        hotelIdList: this.searchParams.hotelIdList,
        dateFrom: this.searchParams.date,
        dateTo: this.searchParams.date
      }
      getLostItemListApi(queryParams)
        .then(res => {
          this.rows = res.data
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.gridLoading = false
        })
    },
    async downloadExcel() {
      this.gridLoading = true
      const queryParams = {
        hotelIdList: this.searchParams.hotelIdList,
        dateFrom: this.searchParams.date,
        dateTo: this.searchParams.date
      }
      getLostItemListApiExcel(queryParams)
        .then(res => {
          const date = this.$moment().format('DD-MM-YYYY')
          downFile(res, 'bao_cao_that_lac_' + date + '.xlsx')
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.gridLoading = false
        })
    }
  }
}
</script>

<style></style>
